import { render, staticRenderFns } from "./DigiBoardList.vue?vue&type=template&id=30b295c5&scoped=true"
import script from "./DigiBoardList.vue?vue&type=script&lang=js"
export * from "./DigiBoardList.vue?vue&type=script&lang=js"
import style0 from "./DigiBoardList.vue?vue&type=style&index=0&id=30b295c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b295c5",
  null
  
)

export default component.exports